import {EPermissions, ScreenProp} from 'src/app/models'

type TKeys = 'PERSETUJUAN_TUGAS' | 'PERSETUJUAN_TUGAS_LIST_WAITING' | 'PERSETUJUAN_TUGAS_LIST_DONE'

export const PersetujuanTugasScreen: Record<TKeys, ScreenProp> = {
  PERSETUJUAN_TUGAS: {
    PATH: '/job/approval-job',
    TITLE: 'Persetujuan Tugas',
    TITLE_ALT: 'Butuh Persetujuan',
  },
  PERSETUJUAN_TUGAS_LIST_WAITING: {
    PATH: '/job/approval-job/list/waiting',
    TITLE: 'Persetujuan Tugas',
    TITLE_ALT: 'Butuh Persetujuan',
    PERMISSION: [EPermissions.JOB_APPROVAL_READ],
  },
  PERSETUJUAN_TUGAS_LIST_DONE: {
    PATH: '/job/approval-job/list/done',
    TITLE: 'Persetujuan Tugas',
    TITLE_ALT: 'Persetujuan Tugas',
    PERMISSION: [EPermissions.JOB_APPROVAL_READ],
  },
}
